import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PaymentDetails from 'Components/ComponentLibrary/Components/Uncategorized/PaymentDetails/index';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  FDStack,
} from '@facet-wealth/design';

const useStyles = buildUseStyles('PaymentDetailsListMeta', (theme) => ({
  img: {
    marginRight: theme.spacing(1),
  },
  typography: {
    fontSize: theme.typography.fontSizePt875Rem,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: `${theme.spacing(2.8)}px`,
  },
  typographyMobile: {
    fontWeight: theme.typography.fontWeightExtraBold,
  },
}));

const PaymentDetailsListMeta = ({
  collection,
}) => {
  const resources = collection?.resources()?.list();
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();

  return (
    <FDStack direction={'column'} spacing={1} alignItems="flex-start" justifyContent="flex-start">
      {resources.map((resource) => {
        const imgSrc = resource.relationship(fr.relationships.logo.name)?.link('related').url() || resource.relationship(fr.relationships.image.name)?.link('related').url();
        const paymentMethod = resource.attr('paymentMethod');
        return (
          <PaymentDetails
            typographyClassName={classNames(classes.typography, { [classes.typographyMobile]: isMobile })}
            imgClassName={classes.img}
            imgSrc={imgSrc}
            details={paymentMethod}
          />
        );
      })}
    </FDStack>
  );
};

PaymentDetailsListMeta.defaultProps = {
};

PaymentDetailsListMeta.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};

export default PaymentDetailsListMeta;
